export default __webpack_public_path__ + "static/media/ladoB.30f8f1ac.png";